export default "__VITE_ASSET__f22a261f__"